import { render, staticRenderFns } from "./GameMore.vue?vue&type=template&id=32a58a96&scoped=true&"
import script from "./GameMore.vue?vue&type=script&lang=js&"
export * from "./GameMore.vue?vue&type=script&lang=js&"
import style0 from "./GameMore.vue?vue&type=style&index=0&id=32a58a96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a58a96",
  null
  
)

export default component.exports